import { Box, useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { tokens } from "../../../../theme";

// import { getOrderStatusCounts } from "../../../api/orders/orders";
import { useTranslation } from 'react-i18next';

import TabView3 from "../../../../components/theme/TabView3/TabView3";
import { useTopbar } from "../../../../contexts/TopbarProvider";
import OutboundShipments from "../orders/views/Shipments";
import Claims from "./views/Claims";
import { warehouseOutboundShipmentsConfig } from "./warehouseOutboundShipmentsConfig";
import { useGetClaimCountsQuery } from "../../../../newapi/claim/claimSlice";
import ShipmentTotalsPanel from "../../../../components/global/dashboard/ShipmentTotalsPanel";
import { useSelector } from "react-redux";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../utils/permissions";


const OutboundShipmentsPage = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { showExtraTitle,clearExtraTitle } = useTopbar();

    const { data: claimCounts } = useGetClaimCountsQuery();
    const config = useMemo(() => warehouseOutboundShipmentsConfig(claimCounts), [claimCounts]);

    // The totals panel belongs to the shipments tab, which reports whether it is the one open.
    const [shipmentsTabActive, setShipmentsTabActive] = useState(false);
    const canViewDashboard = useSelector((state) => selectUserPermission(state, [UserPrivileges.DASHBOARD_READ]));
    const showTotalsPanel = shipmentsTabActive && canViewDashboard;

    useEffect(() => {
        showExtraTitle(t("shipments"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            {showTotalsPanel && <ShipmentTotalsPanel />}

            <TabView3
                tabConfig={config}
                sx={{
                    width:1,
                    background:"green",
                    minHeight: showTotalsPanel ? "calc(100% - 431px)" : "calc(100%)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position:"relative",
                    zIndex:2,

                    display:"flex",
                    flexDirection:"column",

                    "&:before" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        left:0,
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition:"250ms"
                    },

                    "&:after" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        right:0,
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform:"scaleX(-1)",
                        transition:"250ms"
                    },

                    "@media screen and (max-width: 47.9375em)" : {
                        "&:after, &:before" : {
                            top:"-0px"
                        }
                    }
                }}
                title={t("outbound")}
                
            >
                <>
                    <OutboundShipments config={config.shipments} onActiveChange={setShipmentsTabActive}/>
                    <Claims config={config.claims}/>
                </>
            </TabView3>
        </Box>
    );
};

export default OutboundShipmentsPage;